import React from 'react';
import { Check } from 'lucide-react';
import { Button } from './ui/Button';
import { useLanguage } from '../contexts/LanguageContext';
interface ConfirmationScreenProps {
  onReset: () => void;
}
export function ConfirmationScreen({
  onReset
}: ConfirmationScreenProps) {
  const {
    t
  } = useLanguage();
  return <div className="flex flex-col items-center justify-center min-h-[60vh] p-6 text-center animate-in fade-in zoom-in-95 duration-500" data-id="element-87">
      {/* Hero Checkmark */}
      <div className="w-32 h-32 bg-green-100 rounded-full flex items-center justify-center mb-8 shadow-xl shadow-green-100/50" data-id="element-88">
        <Check className="w-16 h-16 text-green-600" strokeWidth={3} data-id="element-89" />
      </div>

      {/* Main Heading */}
      <h1 className="text-5xl font-bold text-gray-900 mb-6 tracking-tight" data-id="element-90">
        {t.confirmation.title}
      </h1>

      {/* Single message */}
      <p className="text-2xl text-gray-800 font-medium mb-10" data-id="element-91">
        {t.confirmation.message}
      </p>

      {/* Info text - no background */}
      <div className="mb-12" data-id="element-92">
        <p className="text-lg text-gray-600" data-id="element-93">{t.confirmation.infoTitle}</p>
      </div>

      {/* Action Button */}
      <Button onClick={onReset} variant="outline" className="h-16 text-xl px-10 w-full max-w-xs border-2 hover:bg-gray-50 transition-all" data-id="element-94">
        {t.confirmation.button}
      </Button>
    </div>;
}